import { addDepeciationAndVariationByModelYear } from './addDepreciationAndVariationByModelYear'
import { getAuto } from './getAuto'
import { getAutoComparador } from './getAuto'
import { getPaginatedListDatamaster } from './getPaginatedListDatamaster'
import { getCurrency } from './getCurrency'
import { getDefaultCurrency } from './getDefaultCurrency'
import { getDepreciationByModel } from './getDepreciationByModel'
import { getPricingValue } from './getPricingValue';
import { getCurrencies } from './getCurrencies';
import { getBrands } from './getBrands';
import { getModels } from './getModels';
import { getVersions } from './getVersions';
import { getYears } from './getYears';
import { getCarLots } from './getCarLots';
import { getCarlot } from './getCarlot';
import { getCarlotsByCatalog } from './getCarlotsByCatalog';
import { getBranchOffices } from './getBranchOffices';
import { getLocations } from './getLocations';
import { getReferencePrices } from './getReferencePrices';
import { getApiPortalCode } from './getApiPortal';
import { getFileAssociation } from './getFileAssociation';
import getCategorySchema from './getCategorySchema'
import { putActivateDatamaster } from './putActivateDatamaster';
import { deleteDatamaster } from './deleteDatamaster';
import { putAssignCodia } from './putAssignCodia';
import {getExcelPrices} from './getExcelPrices';
import { getExcelLatestUpdates } from './getExcelLatestUpdates';
import { getPrices } from './getPrices';
import { uploadExcelPrices } from './uploadExcelPrices';
import { createYearlyPercentageRate } from './createYearlyPercentageRate';
import { getYearlyPercentageRate } from './getYearlyPercentageRate';
import { updatePercentageRate } from './updatePercentageRate';
import { getAllModels } from './getAllModels';
import { getAllVersions } from './getAllVersions';
import { updateDepreciationYear } from './updateDepreciationYear';
import { updateVersionPivot } from './updateVersionPivot'
import { massiveUpdatePrices } from './massiveUpdatePrices';
import { updateVersionPrice } from './updateVersionPrice';
import { getDraftByDepreciation } from './getDraftByDepreciation';
import { getDraftByPriceDetail } from './getDraftByPriceDetail';

export const Datamasters = {
  addDepeciationAndVariationByModelYear,
  getAuto,
  getAutoComparador,
  getPaginatedListDatamaster,
  getCurrency,
  getDepreciationByModel,
  getDefaultCurrency,
  getPricingValue,
  getBrands,
  getModels,
  getVersions,
  getYears,
  getCarLots,
  getCarlot,
  getCarlotsByCatalog,
  getBranchOffices,
  getLocations,
  getReferencePrices,
  getCurrencies,
  getApiPortalCode,
  getFileAssociation,
  getExcelPrices,
  getExcelLatestUpdates,
  getCategorySchema,
  putActivateDatamaster,
  deleteDatamaster,
  putAssignCodia,
  getPrices,
  uploadExcelPrices,
  createYearlyPercentageRate,
  getYearlyPercentageRate,
  updatePercentageRate,
  getAllModels,
  getAllVersions,
  updateDepreciationYear,
  updateVersionPivot,
  massiveUpdatePrices,
  updateVersionPrice,
  getDraftByDepreciation,
  getDraftByPriceDetail
}
